import * as React from 'react';

const SvgArrowDown = ({ width = 16, height = 16, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.666 5L8.33268 11L2.99935 5" stroke="black" />
  </svg>
);

export default SvgArrowDown;
